// extracted by mini-css-extract-plugin
export default {"container":"Paa-z","oos":"Qaa-z","oosUx":"Raa-z","selected":"Saa-z","labelOos":"Taa-z"};